@if (deckComponent.mainLayer.cards?.length) {
    <div class="flex flex-col items-center justify-center gap-4 text-slate-600 w-[80vw] md:w-[60vw] lg:w-[20vw]">
        <div class="flex flex-col items-center justify-center w-[80vw] h-[30vh] md:w-[60vw] md:h-[30vh] lg:w-[20vw] lg:h-[10vw]">
            <canvas baseChart [type]="'pie'" [data]="chartData" [options]="chartOptions" [legend]="false"></canvas>
        </div>
        <div class="text-center">
            Color Breakdown
        </div>
        <div class="text-sm">
            {{ summary }}
        </div>
    </div>
}
